<template>
  <div>
    <v-row justify-sm="end">
      <v-col cols="12" sm="auto">
        <v-text-field
          v-model="search"
          hide-details
          prepend-inner-icon="mdi-magnify"
          color="textLight"
          :placeholder="$t('course.search')"
          outlined
          dense
          background-color="white"
          clearable
          class="shrink rounded-lg my-2"
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <div class="my-0 my-sm-2">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="disable"
                outlined
                block
                style="text-transform: unset"
                class="rounded-lg textLight--text font-weight-thin button"
                height="45"
                v-bind="attrs"
                v-on="on"
                :loading="exportBtnLoading"
              >
                <v-icon>mdi-export</v-icon>
                {{ $t("reports.export") }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in exportItems"
                :key="i"
                class="hand-cursor"
              >
                <v-list-item-title @click="exportTo(item.value)">
                  <div class="d-flex align-center justify-space-between">
                    {{ item.text }}
                    <v-icon size="25" :color="item.iconColor" class="ms-2">{{
                      item.icon
                    }}</v-icon>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    exportBtnLoading: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      filterItems: [
        {
          value: "dates",
          text: this.$t("user.registration.dates"),
        },
      ],
      selectedFilterValue: null,
      selectedFilterText: null,
      search: null,
      exportItems: [
        {
          value: "xl",
          text: this.$t("reports.exportTo"),
          icon: "mdi-microsoft-excel",
          iconColor: "success",
        },
        // {
        //   value: "pdf",
        //   text: this.$t("reports.exportTo"),
        //   icon: "mdi-file-pdf-box",
        //   iconColor: "error",
        // },
      ],
    };
  },
  watch: {
    search() {
      this.$emit("filter", "search", this.search);
    },
  },
  methods: {
    exportTo(val) {
      if (val === "xl") {
        this.$emit("exportToExcel");
      }
    },
  },
};
</script>
